import {SurveyRedactionMark} from "crqlar-react-common/dist/models/survey/surveyRedaction.model";
import {buildSurveyBlackoutSegments} from "./surveyBlackoutSegments";

/** A run of the masked text, flagged for the read-only renderer to draw as a bar or as words. */
export interface SurveyRedactionSegment {
    text: string
    redacted: boolean
}

/**
 * The read-only view's adapter: marks -> segments of the MASKED text.
 *
 * The other side of the boundary from `surveyBlackoutSegments`. A mark addresses the masked string
 * the normal responses carry — mask runs included, original text and length excluded — where the
 * editor's ranges address the original. Only the splitting itself is shared, so both sides cut a
 * string the same way; nothing else crosses.
 *
 * `leadingTrim` rebases marks onto the answer renderer's trimmed string: the server measures from
 * the stored value, the renderer displays it trimmed, and this is the difference between the two.
 */
export const buildSurveyRedactionSegments = (
    text: string,
    marks: SurveyRedactionMark[],
    leadingTrim: number
): SurveyRedactionSegment[] => {
    const ranges = marks
        .filter(mark => mark.maskedStart !== undefined && mark.maskedStart !== null)
        .map(mark => {
            const start = mark.maskedStart - leadingTrim;
            return {id: mark.id, start, end: start + mark.maskedLength};
        })
        .filter(range => range.end > range.start);

    return buildSurveyBlackoutSegments(text, ranges)
        .map(segment => ({text: segment.text, redacted: !!segment.range}));
};
